/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.1",
    versionName: "local 0.4.1",
    versionChannel: "local",
    buildDate: "2026-08-05T15:14:17.664Z",
    commitHash: "5b6f666567449f02cc4c211ab6dc2b510bc094d0",
};
